const footerColumns = [
  {
    title: "快速导航",
    links: [
      { href: "#home", label: "首页" },
      { href: "#process", label: "投稿流程" },
      { href: "#categories", label: "线索分类" },
      { href: "#submit", label: "匿名投稿" },
    ],
  },
  {
    title: "内容与规范",
    links: [
      { href: "#cases", label: "已核实爆料存档" },
      { href: "#faq", label: "投稿常见问题" },
      { href: "#about", label: "关于我们" },
      { href: "#contact", label: "反证与更正" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-10 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center">
                <i className="ri-focus-3-line text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <strong className="font-heading text-xl tracking-wide text-background-50">聚光台</strong>
                <span className="text-[11px] tracking-[0.2em] text-secondary-200">爆料线索中心</span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-100">
              专注网红爆料的线索征集与核验平台。开放匿名投稿通道，征集粉丝私信截图与聊天记录，逐条核验后再发布，让每一条爆料都有据可查。
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm text-secondary-100">
              <a href="mailto:tip@juguangtai.example.com" className="flex items-center gap-2 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                tip@juguangtai.example.com
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.title}>
              <h4 className="font-heading text-base font-bold text-background-50">
                <a href="#home" className="hover:text-accent-400 transition-colors">{col.title}</a>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-100 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-700/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-secondary-200">
            © 2026 聚光台 · 网红爆料线索中心　核验标准公开，拒绝造谣与人身攻击
          </p>
          <p className="text-xs text-secondary-200 flex items-center gap-2">
            <i className="ri-shield-keyhole-line"></i>
            本站投稿信息仅用于线索核验，不作任何其他用途
          </p>
        </div>
      </div>
    </footer>
  );
}